import produce from 'immer';

const INITIAL_STATE = {
  updatedDailyClosedChat: 0,
  getDailyClosedChat: 0
};

export default function updateChatMetrics(state = INITIAL_STATE, action) {
  switch (action.type) {
    case '@UPDATE_DAILY_CLOSED_CHAT':
      return produce(state, (draft) => {
        draft.updatedDailyClosedChat = action.payload.data;
      });
    case '@GET_DAILY_CLOSED_CHAT':
      return produce(state, (draft) => {
        draft.getDailyClosedChat = action.payload.data;
      });
    default:
      return state;
  }
}
